import { Helmet } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import DeveloperScorecardTable from './DeveloperScorecardTable';

export default function DeveloperScorecard() {
  const queryClient = new QueryClient();

  return (
    <>
      <Helmet>
        <title>Developer Scorecard</title>
      </Helmet>
      <QueryClientProvider client={queryClient}>
        <DeveloperScorecardTable />
      </QueryClientProvider>
    </>
  );
}
